import { render, staticRenderFns } from "./MonitoramentoTable.vue?vue&type=template&id=c5172b38&scoped=true&lang=pug"
import script from "./MonitoramentoTable.vue?vue&type=script&lang=js"
export * from "./MonitoramentoTable.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoTable.vue?vue&type=style&index=0&id=c5172b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5172b38",
  null
  
)

export default component.exports